import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useChatStore } from "@/stores/useChatStore";
import { confirmLeaveWithUnsavedFiles } from "@/stores/useUnsavedChangesGuardStore";

/**
 * 未保存のファイルを捨ててよいか確かめてから、指定したチャットへ移動する関数を返す。
 * 確かめてから URL を変えるので、キャンセルしても履歴は残らない。読み込みは ChatUrlSync が行う。
 */
export function useOpenChat(): (chatId: string) => Promise<void> {
	const navigate = useNavigate();
	return useCallback(
		async (chatId: string) => {
			if (chatId !== useChatStore.getState().chatId && !(await confirmLeaveWithUnsavedFiles())) {
				return;
			}
			navigate(`/chats/${chatId}`);
		},
		[navigate],
	);
}
